import { gql } from '@apollo/client'

export const SYSTEM_EVENTS_QUERY = gql`
  query SystemEvents {
    systemEvents {
      stage
      uptime {
        current {
          startDatetime
          expectedConclusion
          status
          description
          reloadRequired
          apiAffected
          webappAffected
          mobileAffected
        }
        historical {
          startDatetime
          expectedConclusion
          status
          description
          reloadRequired
          apiAffected
          webappAffected
          mobileAffected
        }
        planned {
          startDatetime
          expectedConclusion
          status
          description
          reloadRequired
          apiAffected
          webappAffected
          mobileAffected
        }
      }
      versioning {
        current {
          startDatetime
          description
          versionHash
          versionNumber
        }
        historical {
          startDatetime
          description
          versionHash
          versionNumber
        }
        planned {
          startDatetime
          description
          versionHash
          versionNumber
        }
      }
    }
  }
`

// TypeScript interfaces matching the GraphQL schema
export enum ESystemStatus {
  OUTAGE = 'OUTAGE',
  MAINTENANCE = 'MAINTENANCE',
  DEGRADED = 'DEGRADED',
  OPERATIONAL = 'OPERATIONAL',
}

export interface ISystemUptimeEvent {
  startDatetime: string
  expectedConclusion?: string
  status: ESystemStatus
  description: string
  reloadRequired: boolean
  apiAffected?: boolean
  webappAffected?: boolean
  mobileAffected?: boolean
}

export interface ISystemVersioningEvent {
  startDatetime: string
  description: string
  versionHash: string
  versionNumber: string
}

export interface ISystemHistoryObject<T> {
  current: T
  historical: T[]
  planned: T[]
}

export interface ISystemEvents {
  stage: string
  uptime: ISystemHistoryObject<ISystemUptimeEvent>
  versioning: ISystemHistoryObject<ISystemVersioningEvent>
}

export interface SystemEventsQueryResult {
  systemEvents: ISystemEvents
}
